<template>
  <v-app>
    <AppBar />
    <v-main class="main">
      <component :is="layout">
        <transition>
          <router-view></router-view>
        </transition>
      </component>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import MainLayout from '@/layouts/MainLayout.vue'

export default {
  name: 'App',
  components: { AppBar, AuthLayout, MainLayout },
  data: () => ({
    //
  }),
  computed: {
    layout () {
      return this.$route.meta.layout
    }
  },
  watch: {
    '$i18n.locale' (val) {
      this.$vuetify.lang.current = val
    }
  }
}
</script>

<style>
  html {
    overflow-y: hidden;
  }
 .main {
   background-color: #eee;
   max-height: 100vh;
 }
</style>
